import React, { createContext, useContext, useState } from "react";

const QuizContext = createContext(null);
export const useQuiz = () => useContext(QuizContext);

export const QuizProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <QuizContext.Provider value={{ open, openQuiz: () => setOpen(true), closeQuiz: () => setOpen(false) }}>
      {children}
    </QuizContext.Provider>
  );
};
